import React from "react";
import styles from "./index.module.less";

interface LiveDescProps {
  iconName: string;
  showText: string;
}

const LiveDesc: React.FC<LiveDescProps> = ({ iconName, showText }) => {
  return (
    <div className={styles.live_desc}>
      {iconName ? (
        <img
          className={styles.icon}
          src={
            iconName === "hot"
              ? "https://akim-oss.aikucun.com/mshop/f18db00428cf4ad7a7150b32fc6870d33abb297f_1751617996520_34.png"
              : "https://akim-oss.aikucun.com/mshop/1e1fa3803bc615ad59337c7ab129b5c1ee771679_1751618047616_21.png"
          }
        />
      ) : null}
      {showText ? <span>{showText}</span> : null}
    </div>
  );
};

export default LiveDesc;
